// extracted by mini-css-extract-plugin
export default {"appsbar":"AppsBar_appsbar__yAJ4r","searchIcon":"AppsBar_searchIcon__FJHZE","toggles":"AppsBar_toggles__JMyOx","app":"AppsBar_app__h5ojG","active":"AppsBar_active__7Bro0"};